import React from "react";
import { Sun, Moon, Clock } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";
import { useLanguage } from "@/contexts/LanguageContext";

/**
 * Theme toggle — 3 states cycle: AUTO → LIGHT → DARK → AUTO.
 * Compact pill that fits in the navbar next to the FR/EN switch.
 */
const ThemeToggle = ({ className = "", compact = false }) => {
  const { mode, preference, cyclePreference } = useTheme();
  const { lang } = useLanguage();

  const label =
    preference === "auto"
      ? lang === "fr"
        ? "Auto"
        : "Auto"
      : preference === "light"
        ? lang === "fr"
          ? "Clair"
          : "Light"
        : lang === "fr"
          ? "Sombre"
          : "Dark";

  const title =
    preference === "auto"
      ? lang === "fr"
        ? `Auto · résolu en ${mode === "light" ? "clair" : "sombre"} selon l'heure (≥19h = sombre)`
        : `Auto — resolves to ${mode} based on time (≥7pm = dark)`
      : lang === "fr"
        ? `Manuel · ${preference === "light" ? "clair" : "sombre"}. Cliquez pour changer.`
        : `Manual · ${preference}. Click to switch.`;

  const Icon =
    preference === "auto" ? Clock : preference === "light" ? Sun : Moon;

  return (
    <button
      type="button"
      onClick={cyclePreference}
      title={title}
      aria-label={title}
      data-testid="theme-toggle"
      className={`inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] font-medium px-2.5 py-1.5 rounded-full border transition-colors ${
        compact ? "" : "md:gap-2 md:text-[11px] md:tracking-[0.3em] md:px-3"
      } border-[var(--kw-border-strong,#F2EBE51F)] text-[var(--kw-text)] hover:text-[var(--kw-gold)] hover:border-[var(--kw-gold)]/40 ${className}`}
    >
      <Icon className="w-3.5 h-3.5 md:w-4 md:h-4 text-[var(--kw-gold)]" strokeWidth={1.5} />
      <span className="hidden md:inline">{label}</span>
    </button>
  );
};

export default ThemeToggle;
